import CreateReportTemplateController from "./create-report-template-controller";
import { getValue } from "store/languages";
import { compose } from "redux";
import { connect } from "react-redux";
import { createReportConstructorTemplate, copyTemplate } from "store/report-constructor";
import { modalShowToggle } from "store/modal";

let mapStateToProps = (state) => {
    return {
        blank: null
    }
}

const CreateReportTemplateContainer = (CreateReportTemplateController);

export default compose(
    connect(
        mapStateToProps, {
            getValue,
            createReportConstructorTemplate,
            copyTemplate,
            modalShowToggle
        }
    )
) (CreateReportTemplateContainer)